import { FormEventHandler, useState } from "react"
import { Link, useForm } from "@inertiajs/react"
import { AppLayout } from "../../components/AppLayout"
import { Field } from "../../components/Field"
import { TextInput } from "../../components/TextInput"
import { isIsraeliMobilePhone, sanitizePhoneInput } from "../../utils/phone"

type Form = {
  name: string
  username: string
  email: string
  phone: string
  password: string
  password_confirmation: string
}

export default function Register() {
  const [phoneError, setPhoneError] = useState("")
  const { data, setData, post, processing, errors } = useForm<Form>({
    name: "",
    username: "",
    email: "",
    phone: "",
    password: "",
    password_confirmation: "",
  })

  const submit: FormEventHandler = (event) => {
    event.preventDefault()
    if (data.phone && !isIsraeliMobilePhone(data.phone)) {
      setPhoneError("הזינו מספר נייד ישראלי תקין")
      return
    }
    setPhoneError("")
    post("/register")
  }

  return (
    <AppLayout title="יצירת חשבון">
      <div className="mx-auto grid max-w-md gap-4 pt-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold">יצירת חשבון</h1>
          <p className="mt-2 text-slate-600">פתיחה מהירה של אזור ניהול</p>
        </div>

        <form onSubmit={submit} className="glass-card space-y-4 p-6">
          <Field label="שם" error={errors.name}>
            <TextInput value={data.name} onChange={(e) => setData("name", e.target.value)} />
          </Field>
          <Field label="שם משתמש" error={errors.username} hint="לכניסה מהירה בלי לזכור אימייל">
            <TextInput dir="ltr" value={data.username} onChange={(e) => setData("username", e.target.value)} />
          </Field>
          <Field label="אימייל" error={errors.email}>
            <TextInput type="email" value={data.email} onChange={(e) => setData("email", e.target.value)} />
          </Field>
          <Field label="טלפון" error={errors.phone || phoneError} hint="נוכל לאפשר כניסה מהירה עם קוד SMS">
            <TextInput dir="ltr" type="tel" inputMode="tel" maxLength={16} value={data.phone} onChange={(e) => { setData("phone", sanitizePhoneInput(e.target.value)); setPhoneError("") }} placeholder="050-0000000" />
          </Field>
          <Field label="סיסמה" error={errors.password}>
            <TextInput type="password" value={data.password} onChange={(e) => setData("password", e.target.value)} />
          </Field>
          <Field label="אימות סיסמה" error={errors.password_confirmation}>
            <TextInput type="password" value={data.password_confirmation} onChange={(e) => setData("password_confirmation", e.target.value)} />
          </Field>
          <button disabled={processing} className="btn-primary w-full bg-brand-600">
            הרשמה
          </button>
        </form>

        <p className="text-center text-sm text-slate-600">
          כבר יש לך חשבון? <Link href="/login" className="font-medium text-brand-700">כניסה</Link>
        </p>
      </div>
    </AppLayout>
  )
}
